// data/faqs.js
export const faqs = [
  {
    question: "How do I get started?",
    answer: "Apply through our form or talk to us on telegram with your goals and content examples."
  },
  {
    question: "How quickly will I see results?",
    answer: "Most clients see initial engagement within 24-48 hour of campaign launch. for our community boost package, results are visible within hours. The impact mostly depends on your package choice and current follower base."
  },
  {
    question: "How does our Twitter/X growth system work?",
    answer: "We use curated networks of real people (Telegram based)who are active in the Solana trenches. When someone subscribes, their tweets are automatically sent to the group’s announcements, and members engage. 90% of subscription money goes into the group pool and is distributed by hierarchy ensuring authentic, human engagement"
  },
  {
    question: "Do I need to give you my X credentials or connect X in any way?",
    answer: "No. We never ask for your credentials."
  },
  {
    question: "If I subscribe to a 'Package for Creators' how many of my tweets get boosted?",
    answer: "Every single tweet you post for a period of one month regardless of the number of tweets you make. You can make 10 tweets a day, we don’t mind!"
  },
  {
    question: "Can my account get suspended?",
    answer: "No. We comply with platform rules and only use organic engagement."
  },
  {
    question: "Do you offer active support?",
    answer: "Yes. Our Telegram support is active 24/7."
  }
];
